import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LangType } from '@Interfaces/interfaces';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '@Services/language.service';
import { DialogWrapperComponent } from '../dialog-wrapper/dialog-wrapper.component';
import { NavigationService } from '@Services/navigation.service';
import { TicketPurchaseService } from '@Services/ticket-purchase.service';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'language-select-dialog',
    imports: [DialogWrapperComponent, TranslateModule, FormsModule, CommonModule],
    templateUrl: './language-select-dialog.component.html',
    styleUrl: './language-select-dialog.component.scss'
})
export class LanguageSelectDialogComponent implements OnInit, OnDestroy {

  @ViewChild('wrapper')
  protected wrapper!:DialogWrapperComponent;

  @Output()
  public languageDialogClose: EventEmitter<Event> = new EventEmitter();

  public supportedLanguages!: LangType[];

  public selectedLang!: LangType | null;

  public currentLangUsed: LangType;

  private destroy$ = new Subject<void>();

  constructor(
    private langSvc: LanguageService,
    protected ticketSvc:TicketPurchaseService,
    private navigationSvc: NavigationService,
  ){
    this.currentLangUsed = this.langSvc.$language.getValue();
    this.supportedLanguages = this.langSvc.$supportedLanguages.getValue();
  }

  ngOnInit(): void {
    this.listenLangChange();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private listenLangChange() {
    this.langSvc.getLanguage()
    .pipe(
      takeUntil(this.destroy$)
    )
    .subscribe(lang => {
      this.currentLangUsed = lang;
    });
  }

  public showModal() {
    this.wrapper.showModal();
    this.selectedLang = this.langSvc.$language.getValue();
  }

  public wrapperClose() {
    this.languageDialogClose.emit();
  }

  public onCloseDialog() {
    this.wrapper.close();
  }

  public selectLanguage(){
    this.langSvc.switchLanguage(this.selectedLang!);
    this.navigationSvc.resetSteps();
    this.ticketSvc.clearAllSelections();
    this.onCloseDialog();
  }

}
